import { render, staticRenderFns } from "./ChatCounter.vue?vue&type=template&id=4b901208&scoped=true&"
import script from "./ChatCounter.vue?vue&type=script&lang=js&"
export * from "./ChatCounter.vue?vue&type=script&lang=js&"
import style0 from "./ChatCounter.vue?vue&type=style&index=0&id=4b901208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b901208",
  null
  
)

export default component.exports